import request from "@/utils/request";
import { IEviSubjectbehavior } from "../model/evisubjectbehavior";

// 实体
export const defaultEviSubjectbehaviorData: IEviSubjectbehavior = {
  id: 0,
  subjectId: "",
  dictId: 0,
  value: "",
  createTime: null,
  creatorId: "",
  updateTime: null,
  updateId: "",
  sort: 0
};

export const getEviSubjectbehavior = (id: any) => {
  request({
    url: "/EviSubjectbehavior/Get",
    method: "post",
    params: { id: id }
  });
};

export const addEviSubjectbehavior = (data: any) =>
  request({
    url: "/EviSubjectbehavior/Add",
    method: "post",
    data
  });

export const updateEviSubjectbehavior = (data: any) =>
  request({
    url: "/EviSubjectbehavior/Update",
    method: "post",
    data
  });

export const deleteEviSubjectbehavior = (id: string) =>
  request({
    url: "/EviSubjectbehavior/Delete",
    method: "post",
    params: { id: id }
  });

export const getEviSubjectbehaviorPageList = (data: any) =>
  request({
    url: "/EviSubjectbehavior/GetPageListAsync",
    method: "post",
    data
  });

export const GetSubjectbehaviorBySubjectId = (id: any) =>
  request({
    url: "/EviSubjectbehavior/GetSubjectbehaviorBySubjectId",
    method: "post",
    params: { SubjectId: id }
  });

export const saveListAsync = (data: any) =>
  request({
    url: "/EviSubjectbehavior/SaveListAsync",
    method: "post",
    data
  });

export const getSubjectbehaviorFromDict = (subjectId: any) =>
  request({
    url: "/EviSubjectbehavior/GetSubjectbehaviorFromDict",
    method: "post",
    params: { subjectId: subjectId }
  });

export const saveAsync = (data: any) =>
  request({
    url: "/EviSubjectbehavior/SaveAsync",
    method: "post",
    data
  });

export const deleteByDictId = (dictId: any) =>
  request({
    url: "/EviSubjectbehavior/DeleteByDictId",
    method: "post",
    params: { dictId: dictId }
  });

export const getCurrentSubjectbehaviorArr = () =>
  request({
    url: "/EviSubjectbehavior/GetCurrentSubjectbehaviorArr",
    method: "post"
  });
